export default {
  ERROR_GETTING_NOTIFICATIONS: "There was an error getting your notifications",
};
